import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'ProjectIcon',
  'project',
  'M102.4 652.8c0 84.831 68.769 153.6 153.6 153.6h141.513c58.18 0 111.366-32.871 137.383-84.908l8.745-17.492h224.358c84.833 0 153.6-68.769 153.6-153.6v-256c0-84.833-68.767-153.6-153.6-153.6h-512c-84.831 0-153.6 68.767-153.6 153.6v358.4zM256 704c-28.277 0-51.2-22.923-51.2-51.2v-358.4c0-28.278 22.923-51.2 51.2-51.2h512c28.278 0 51.2 22.922 51.2 51.2v256c0 28.277-22.922 51.2-51.2 51.2h-224.358c-38.785 0-74.242 21.914-91.588 56.605l-8.746 17.492c-8.673 17.346-26.402 28.303-45.795 28.303h-141.513z',
)
